export default __webpack_public_path__ + "static/media/laboratory-icon.e886aea1.svg";